import { render, staticRenderFns } from "./RoomAppBar.vue?vue&type=template&id=1c9c2259&lang=pug&"
import script from "./RoomAppBar.vue?vue&type=script&lang=ts&"
export * from "./RoomAppBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoomAppBar.vue"
export default component.exports